import { useContext } from 'react';

import { CurrencyContext } from '../contexts/CurrencyContext';

export const CURRENCY_SYMBOLS = {
    usd: '$',
    eur: '€',
} as const;

export const useCurrencyContext = () => {
    const context = useContext(CurrencyContext);

    if (!context) {
        throw new Error('useCurrencyContext must be used within a CurrencyProvider');
    }

    return { ...context, currencySymbol: CURRENCY_SYMBOLS[context.currency] };
};
